import SocialButtonFacebookContainer from './SocialButtonFacebook.container';
import SocialButtonFacebook from './SocialButtonFacebook';
export default SocialButtonFacebookContainer(SocialButtonFacebook);
